module.exports = __webpack_public_path__ + "img/mutual-of-omaha.1e14314a.png";